/** @format */

import React, { useState } from "react";
import { Button, Modal, Spinner, Alert } from "react-bootstrap";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash.svg";
import { ResourceReference, Subject } from "../../types";
import { useLocale } from "../../i18n/hooks";
import { useDeleteSubjectMutation } from "../../app/services/subjectApi";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../app/hooks";
import { subjectApiSlice } from "../../app/services/subjectApi";

type Props = {
  subject: Subject
}

const DeleteSubject: React.FC<Props> = ({ subject }) => {
  const locale = useLocale();
  const { t: _ } = useTranslation();
  
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteSubject] = useDeleteSubjectMutation();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [enReferences, setEnReferences] = useState<ResourceReference[]>()
  const [cyReferences, setCyReferences] = useState<ResourceReference[]>()

  const fetchAnyReferences = async () => {
    const _enReferences = await dispatch(subjectApiSlice.endpoints.getResourcesFromSubject.initiate({code: subject.id, locale: "en"})).unwrap()
    const _cyReferences = await dispatch(subjectApiSlice.endpoints.getResourcesFromSubject.initiate({code: subject.id, locale: "cy"})).unwrap()

    setEnReferences(_enReferences)
    setCyReferences(_cyReferences)

    setIsLoading(false)
  }

  return (
    <>
      <td className="ps-5">
        <Button variant="danger" onClick={() => {setIsLoading(true); fetchAnyReferences(); setShowDeleteModal(true)}}>
          <Trash className="text-red" />
        </Button>
      </td>
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        aria-label="delete-subject-modal"
        centered
      >
        <Modal.Header closeButton>{_("deleteSubject.heading")}</Modal.Header>
        <Modal.Body>
          <p>{_("deleteSubject.message")}</p>
          <p>
            {subject.title[locale]}
            <br />
            <code>{subject.id}</code>
          </p>
          { isLoading ? (
            <p>{_("deleteSubject.fetchingResources")} <Spinner size="sm"/></p>
          ) : ( !(enReferences?.length === 0) || !(cyReferences?.length === 0)) && (
            <Alert variant="danger">
              {_("deleteSubject.resourcesAttached")}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex gap-3 justify-content-end">
            <Button
              role="button"
              variant="outline-editing"
              onClick={() => setShowDeleteModal(false)}
            >
              {_("deleteSubject.cancel")}
            </Button>
            <Button
              disabled={isLoading || ( !(enReferences?.length === 0) || !(cyReferences?.length === 0))} //isloading
              role="button"
              variant="danger"
              onClick={async () => {
                // DELETE SUBJECT
                await deleteSubject(subject.id);
                setShowDeleteModal(false);
              }}
            >
              {_("deleteSubject.delete")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteSubject;
